import React from "react";
import Characters from "./components/Characters";
import "./App.css";

function App() {
  return (
    <main className="mainClass">
      <div className="App">
        <h1>Rick & Morty FrontEnd Challenge</h1>
        <Characters />
      </div>
    </main>
  );
}

export default App;
